import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MobileHeader from '../MobileHeader';
import { CustomButton } from '../Button/Button';
import styles from '../ProtectedVideoModal/ProtectedVideoModal.module.scss';

const LoginRequiredModal = ({ onLogin }) => {
  const mediaMatch = window.matchMedia('(max-width: 900px)');
  const [isMobileView] = useState(mediaMatch.matches);
  const { t } = useTranslation();

  if (isMobileView) {
    return (
      <>
        <MobileHeader showMenuBtn={true} />
        <div className={styles.mobilePasswordContainer}>
          <h2>{t('video.login_required_modal.title')}</h2>
          <p className={styles.mobileText}>{t('video.login_required_modal.text')}</p>
          <CustomButton
            variant="primary"
            label={t('video.login_required_modal.button.label')}
            onClick={onLogin}
            className={styles.mobileSubmitButton}
          />
        </div>
      </>
    );
  }

  return (
    <div className={styles.pageContainer}>
      <div className={styles.overlayContainer}>
        <div className={styles.overlaySection}>
          <p className={styles.heading}>{t('video.login_required_modal.title')}</p>
          <p className={styles.subHeading}>{t('video.login_required_modal.text')}</p>
          <CustomButton
            variant="primary"
            label={t('video.login_required_modal.button.label')}
            onClick={onLogin}
            className={styles.submitButton}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginRequiredModal;
